export default "__VITE_ASSET__B$N9FoLV__"